module.exports = __webpack_public_path__ + "img/sign-active.a5534ec6.png";